import {Injectable} from "@angular/core";
import {Http, URLSearchParams} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {FamiliesService} from "../families.service";
import {Page} from "../../model/page";
import {Comment} from "../../model/comment";
import {Picture} from "../../model/picture";

@Injectable()
export class CommentService extends FamiliesService {

    constructor(private http:Http, private urlService:UrlService, private authent:AuthentService) {
        super();
    }

    getEventComments(eventId:number, page:number, pageSize:number):Observable<Page<Comment>> {
        let params:URLSearchParams = new URLSearchParams();
        params.set('page', String(page));
        params.set('pageSize', String(pageSize));

        let options = this.authent.getJSONAuthentHeaders();
        options.search = params;

        return this.http.get(this.urlService.getEventCommentsUrl(eventId), options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteComment(eventId:number, commentId:number):Observable<any> {
        return this.http.delete(this.urlService.getDeleteCommentUrl(eventId, commentId), this.authent.getAuthentHeaders())
            .catch(this.handleError);
    }

    getPictureComments(eventId:number, pictureId:number, page:number, pageSize:number):Observable<Page<Comment>> {
        let params:URLSearchParams = new URLSearchParams();
        params.set('page', String(page));
        params.set('pageSize', String(pageSize));

        let options = this.authent.getJSONAuthentHeaders();
        options.search = params;

        return this.http.get(this.urlService.getPictureCommentsUrl(eventId, pictureId), options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getPictureFromComment(commentId:number):Observable<Picture> {
        return this.http.get(this.urlService.getPictureFromCommentUrl(commentId), this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/comment.service.ts